// extracted by mini-css-extract-plugin
export default {"container":"BlogDetails_container__B5lko"};